import { render, staticRenderFns } from "./DetailSaleManagementDaily.vue?vue&type=template&id=64e74d5c&"
import script from "./DetailSaleManagementDaily.vue?vue&type=script&lang=js&"
export * from "./DetailSaleManagementDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports